import { getInstance } from "./index";
import { watchEffect } from "vue";

export default (to, from, next) => {
  const authService = getInstance();

  const checkAuth = async () => {
    if (authService.state.isAuthenticated) {
      return next();
    } else {
      authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
    }
  };

  if (!authService.state.loading) {
    return checkAuth();
  }

  // Watch for the loading state to change before proceeding
  watchEffect(() => {
    if (!authService.state.loading) {
      checkAuth();
    }
  });
};
